/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './ArrowHeadIcon.style';

import svg from './arrow-head.svg';

type Props = {
  className?: string,
  title?: string,
  left?: boolean,
  right?: boolean,
  up?: boolean,
  down?: boolean,
  // Self passed
};

const useStyles = createUseStyles(styles);

const ArrowHeadIcon = ({
  className,
  title,
  right,
  up,
  down,
}: Props): React.Node => {
  const classes: Object = useStyles();

  const rootClasses = classNames(classes.root, className, {
    [classes['root-right']]: right,
    [classes['root-up']]: up,
    [classes['root-down']]: down,
  });

  return <BaseIcon className={rootClasses} svg={svg} title={title} />;
};

export default compose(React.memo)(ArrowHeadIcon);
